export enum DnsSurface {
  MarketingSending = "marketing_sending",
  SupportInbound = "support_inbound",
  Contextual = "contextual",
  ReturnsDomain = "returns_domain",
}
